import axios from 'axios';
import { restUrl } from '../../env';
import { sessionUsername } from './LoginManager'

export let isAdminUser = undefined;

export async function AttemptAdminPortalLoginFlow( loginCallback )
{

  if( !sessionUsername )
  {
    loginCallback( { success: false, error: "User not logged in yet." } );
    return;
  }

  const response = await axios.post( `${restUrl}/auth/verifyAdmin`, {}, { withCredentials: true } );

  if( !response )
  {
    isAdminUser = false;
    loginCallback( { success: false, error: "Server error." } );
  }
  else if( !response.data.success )
  {
    isAdminUser = false;
    loginCallback( { success: false, error: response.data.error } );
  }
  else
  {
    isAdminUser = true;
    loginCallback( { success: true } );
  }
}

